module.exports = "/_next/static/images/b3e0c80d513bb2ecf59b6c2310f7caac-apply-lg.jpg";